import find from 'lodash/find';

export class ContactInfoService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
        this.apiService = ApiService;

        this.contactInfoResourceUrl = this.apiService.getResourceUrl('cms/menus/ContactInfo');
        this.editContactInfoResourceUrl = this.apiService.getResourceUrl('cms/contact-info');

        this.contactInfoResource = this.$resource(this.contactInfoResourceUrl);
        this.editContactInfoResource = this.$resource(this.editContactInfoResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
    }

    /************
     * To get Contact Info
     ***************/
    getContactInfoObject({ data }) {
        return this._getSubContentDetails(find(data.content, ['name', 'ContactInfo']).values[0])
    }

    /*************
     * To Update Contact Info
     *****************/
    editContactInfo(details) {
        let contactDetails = this._setContactInfoDetails(details);
        const promise = this.editContactInfoResource.update(contactDetails).$promise;

        return promise
            .then(details => details)
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            })
    }

    //*************************************Private Methods********************************* */

    _getSubContentDetails(value) {
        return {
            email: value.email || "",
            phone: this._getPhoneDetailsObject(value.phone),
            address: this._getAddressDetailsObject(value.address)
        }
    }

    _getPhoneDetailsObject(phone) {
        phone = Array.isArray(phone) ? phone : [phone];

        return phone.map(({ extn, number }) => ({
            extn,
            number
        }));
    }

    _setPhoneDetailsObject(phone) {
        return phone.map(({
            extn,
            number
        }) => ({
                extn,
                number
            }));
    }

    _setContactInfoDetails({ email, phone, address }) {
        return {
            email,
            phone: this._setPhoneDetailsObject(phone),
            address: this._setAddressDetailsObject(address)
        }
    }

    _getAddressDetailsObject(address = {}) {
        return {
            addressLine1: address.address_line_1 || "",
            addressLine2: address.address_line_2 || "",
            stateName: address.state_name || "",
            cityName: address.city_name || "",
            zipCode: address.zip_code || ""
        };
    }

    _setAddressDetailsObject({
        addressLine1: address_line_1,
        addressLine2: address_line_2,
        stateName: state_name,
        cityName: city_name,
        zipCode: zip_code
    }) {
        return {
            address_line_1,
            address_line_2,
            state_name,
            city_name,
            zip_code
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/components/contact-info/contact-info.service.js